export default __webpack_public_path__ + "static/media/jeremy.576232af.jpg";